import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import api from '@/shared/api/api';
import EmployeeForm from './EmployeeForm';
import { useFetch } from '@/shared/hooks/useFetch';
import { EmployeeResponseDTO, EmployeeUpdateDTO } from '@/shared/api/gen/data-contracts';
import { AdminLayout } from '@/components/Layout/Layout';
import Button from '@/shared/ui/Buttons/Button';
import Form from '@/shared/ui/Form/Form';
import PasswordInput from '@/shared/ui/Inputs/PasswordInput';

function EmployeeUpdate() {
    const navigate = useNavigate();
    const { employeeID: id } = useParams();
    const { data } = useFetch(
        () => id ? api.employees.getEmployeesDetailApiEmployeesIdGet(+id) : Promise.resolve({} as any),
        {} as EmployeeResponseDTO,
        [id]
    );

    const { register, handleSubmit, reset } = useForm<{ password: string }>();
    const [passwordSaved, setPasswordSaved] = useState(false);

    const onSubmit = (formData: EmployeeUpdateDTO) => {
        if (id) {
            api.employees.updateEmployeesApiEmployeesIdPut(+id, formData).then(() => navigate('/employees'));
        }
    };

    const onPasswordSubmit = async ({ password }: { password: string }) => {
        if (!id) return;
        await api.employees.updateEmployeePasswordApiEmployeesIdPasswordPatch(+id, { password });
        reset();
        setPasswordSaved(true);
        setTimeout(() => setPasswordSaved(false), 3000);
    };

    return (
        <AdminLayout>
            <div className='FormRow'>
                <Button onClick={() => navigate(-1)} style={{ maxWidth: '100px' }}>Назад</Button>
                <h1 className='text-30'>Редактирование сотрудника №{id} {data?.name}</h1>
            </div>
            <EmployeeForm defaultData={data} onSubmit={onSubmit} isEdit />
            <Form onSubmit={handleSubmit(onPasswordSubmit)} style={{ maxWidth: '560px' }}>
                <h2 className='text-24'>Смена пароля</h2>
                <PasswordInput label="Новый пароль" register={register("password", { required: "обязательное поле" })} />
                <Button type="submit">{passwordSaved ? 'Сохранено!' : 'Сменить пароль'}</Button>
            </Form>
        </AdminLayout>
    );
}

export default EmployeeUpdate;
